import {
  Divider,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CustomButton from "../../components/CustomButton";
import { mainColor } from "../../constants";
import MenuItem from "@mui/material/MenuItem";
import * as Yup from "yup";
import { Formik } from "formik";
import DeleteIcon from "@mui/icons-material/Delete";
import DangerousIcon from '@mui/icons-material/Dangerous';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import {createDoc} from '../../utils/firebase/dynamic'
import { makeStyles } from "@mui/styles";
const NewPlan = () => {
  const useStyles = makeStyles((theme) => ({
    helperText: {
      color: "red"
    }
  }));
  const classes = useStyles()
  const [points, setPoints] = useState([]);
  const [point, setPoint] = useState({ text: "", err: "" });
  const [usage, setUsage] = useState([
    {
      price: 0,
      terms: "",
    },
  ]);
  const [usagePrice, setUsagePrice] = useState({
    value: 0,
    vErr: "",
    terms: "",
    tErr: "",
  });
  const [successAction,setSucessAction]=useState({visible:false,success:true,});
  const [saveErr, setSaveErr] = useState("");
  const [saveLoad, setSaveLoad] = useState(false);
  const handleUsageChange = (text, type = "price") => {
    if (type == "price") {
      if (Number(text).toString() === "NaN")
        return setUsagePrice((p) => ({
          ...p,
          value: text,
          vErr: "Must be a number",
        }));
      if (typeof +text === "number" && +text <= 0)
        return setUsagePrice((p) => ({
          ...p,
          value: text,
          vErr: "Can't be less than 1.",
        }));
      setUsagePrice((p) => ({ ...p, value: text, vErr: "" }));
    } else {
      if (text.trim().length < 3 || !text.trim() || text == "")
        return setUsagePrice((p) => ({
          ...p,
          terms: text,
          tErr: "Required and should be more than 3 chars",
        }));
      setUsagePrice((p) => ({ ...p, terms: text, tErr: "" }));
    }
  };
  const addFeature = () => {
    if (point.text.trim().length < 3 || !point.text.trim() || point.text == "")
      return setPoint((p) => ({
        ...p,
        err: "Can't be empty or it's length be less than 3 characters",
      }));
    setPoints((p) => [...p, point.text]);
    setPoint({ text: "", err: "" });
  };
  
  
  const handleSubmit = async (values, { resetForm }) => {
    setSucessAction({visible:false,success:true});
    const { value, tErr, vErr, terms } = usagePrice;
    if (values.onUsage && (!value || !terms || vErr || tErr))
      return setSaveErr(
        "Please complete missing fileds or correct invalid fields's data"
      );
    if (points.length < 1)
      return setSaveErr("Please add at least one feature for your plan");
    setSaveErr("");
    setSaveLoad(true);
    try {
      const data = {
        descriptionPoint: points,
        hour: +values.hours,
        minutes: +values.hours * 60,
        name: `${values.price}$ for ${values.hours} hours (${
          values.hours * 60
        } minutes)`,
        onUsage: values.onUsage,
        pricePlan: +values.price,
        status: "active",
        title: values.name,
        returnUrl: "expert-minutes",
        usage:values.onUsage? [{ terms: usagePrice.terms, price: +usagePrice.value }]:null,
        description: values.desc,
      };
      console.log("data is", data);
      const isAdded=await createDoc("plans",data)
      if(isAdded){
        setPoints([]);
        setUsagePrice({
          value: 0,
          vErr: "",
          terms: "",
          tErr: "",
        });
        
        resetForm();
        setSucessAction({visible:true,success:true});
        setTimeout(() => {
          setSucessAction({visible:false,success:true});
          
        }, 3000);
      }else{
        setSucessAction({visible:true,success:false});
      }
      setSaveLoad(false);
    } catch (e) {
      console.log("e.saving plan", e.message);
      setSaveLoad(false);
    }
  };
  const validateSchema = Yup.object().shape({
    name: Yup.string()
      .min(3, "Name should be more than 2 characters ")
      .max(18)
      .required("Required"),
    desc: Yup.string()
      .min(4, "Desctiption should be more than 4 characters")
      .max(30)
      .required("Required"),
    // litlDes: Yup.string().min(3).max(24).required("Required"),
    price: Yup.number()
      .min(1, "Can't be less than 1")
      .typeError("The price must be a number type")
      .required("Required"),
    hours: Yup.number()
      .min(1, "Can't be less than 1")
      .typeError("Hours must be a number type")
      .required("Required"),
    hasUsage: Yup.boolean(),
  });
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          // alignItems:"center",
          // height:"100vh",
          width: "90%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            margin: "10px 0px",
          }}
        >
          <Typography variant="h6" style={{ fontSize: 30 }}>
            Add new plan
          </Typography>
        </div>
        <Formik
          initialValues={{
            name: "",
            desc: "",
            price: 1,
            hours: 1,
            onUsage: false,
            usage: [],
            usagePrice: 1,
            usageTerms: "",
            returnUrl: "expert-minutes",
            minutes: 0,
          }}
          onSubmit={handleSubmit}
          validationSchema={validateSchema}
        >
          {({
            handleBlur,
            handleChange,
            values,
            errors,
            handleSubmit,
            touched,
            isValid,
          }) => (
            <Paper
              sx={{
                p: "20px",
                boxShadow:
                  "0px 2px 12px -4px rgba(58, 53, 65, 0.1), 0px 2px 12px -4px rgba(58, 53, 65, 0.08), 0px 6px 16px -4px rgba(58, 53, 65, 0.1)",
              }}
            >
              {/* name desctiption litlDes */}
              <div
                style={{
                  margin: "10px 0px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    margin: "10px 0px",
                  }}
                >
                  <div style={{ marginRight: 20, width: "100%",height:70 }}>
                    <TextField
                      autoFocus
                      id="name"
                      label="Plan Name"
                      type="text"
                      fullWidth
                      onChange={handleChange("name")}
                      onBlur={handleBlur("name")}
                      value={values.name}
                      helperText={errors.name}
                      required
                      FormHelperTextProps={{
                        color: "red",
                        className: classes.helperText
                      }}
                    />
                  </div>
                  <div style={{  width: "100%",height:70 }}>
                    <TextField
                      id="desc"
                      label="Description"
                      placeholder="ex:good start for everyone "
                      type="text"
                      fullWidth
                      onChange={handleChange("desc")}
                      onBlur={handleBlur("desc")}
                      helperText={errors.desc}
                      value={values.desc}
                      required
                      FormHelperTextProps={{
                        color: "red",
                        className: classes.helperText
                      }}
                    />

                  </div>
                </div>
                {/* discreption div */}
                {/* <TextField
                  margin="dense"
                  id="name"
                  label="Decsription"
                  placeholder="ex:20$ for 2 hours(120 minutes)"
                  type="text"
                  fullWidth
                  onChange={handleChange("desc")}
                  value={values.desc}
                  required
                /> */}
              </div>
              {/* features */}
              <div
                style={{
                  margin: "20px 0px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    // justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <FormControl sx={{ width: "100%" }} variant="outlined">
                    <InputLabel>Plan feature</InputLabel>
                    <OutlinedInput
                      onChange={(e) =>
                        setPoint({ text: e.target.value, err: "" })
                      }
                      value={point.text}
                      // id="outlined-adornment-password"
                      type={"text"}
                      placeholder="Features or goods of  the plan"
                      endAdornment={
                        // <InputAdornment position="end">
                        <button
                          style={{
                            backgroundColor: mainColor,
                            cursor: "pointer",
                            height: 56,
                            width: 80,
                            padding: 10,
                            color: "white",
                            border: "0px",
                            position: "absolute",
                            right: 0,
                          }}
                          onClick={addFeature}
                        >
                          ADD
                        </button>
                        // </InputAdornment>
                      }
                      label="Password"
                    />
                    <FormHelperText id="outlined-weight-helper-text">
                      {point.err}
                    </FormHelperText>
                  </FormControl>
                </div>
                {/* points */}
                <div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{
                      fontSize:16,
                      color:"#000000"
                    }}>
                      Plan's features:
                    <span style={{
                      color:"GrayText",
                      fontSize:14
                    }}  >
                      &nbsp; must add at least one feature.
                    </span>
                    </p>
                  </div>
                  {points.map((point) => (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginLeft: 10,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              height: 5,
                              width: 5,
                              borderRadius: "50%",
                              backgroundColor: "gray",
                              marginRight: 10,
                            }}
                          ></div>
                          <Typography color={"#000000"} variant="body1">
                            {point}
                          </Typography>
                        </div>
                        <IconButton
                          onClick={() =>
                            setPoints((p) => p.filter((i) => i !== point))
                          }
                        >
                          <DeleteIcon color="error" />
                        </IconButton>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <Divider />
              {/* price hours */}
              <div
                style={{
                  display: "flex",
                  // flexDirection:"column",
                  margin: "20px 0",
                  // justifyContent: "space-between",
                }}
              >
                <div style={{ flex: 0.4, marginRight: 20 }}>
                  <TextField
                    sx={{ width: "100%" }}
                    id="outlined-select-currency"
                    select
                    label="Can have bundles after finish "
                    value={values.onUsage}
                    onChange={handleChange("onUsage")}
                  >
                    {[
                      { label: "Yes", value: true },
                      { label: "No", value: false },
                    ].map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
                {values.onUsage && (
                  <div
                    style={{
                      display: "flex",
                      flex: 0.6,
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ marginRight: 20, width: "100%",height:70 }}>
                      <TextField
                        id="name"
                        label="Price"
                        placeholder="Bundle price"
                        type="text"
                        fullWidth
                        onChange={(e) =>
                          handleUsageChange(e.target.value, "price")
                        }
                        value={usagePrice.value}
                        helperText={usagePrice.vErr}
                        required
                        FormHelperTextProps={{
                          color: "red",
                          className: classes.helperText
                        }}
                      />
                    </div>
                    <div style={{  width: "100%",height:70 }}>
                      <TextField
                        id="name"
                        label="Bundle Decsription"
                        // placeholder="ex:20$ for 2 hours(120 minutes)"
                        type="text"
                        fullWidth
                        onChange={(e) =>
                          handleUsageChange(e.target.value, "terms")
                        }
                        value={usagePrice.terms}
                        helperText={usagePrice.tErr}
                        required
                        FormHelperTextProps={{
                          color: "red",
                          className: classes.helperText
                        }}
                      />
                    </div>
                    {/* <button
                    style={{
                      backgroundColor: mainColor,
                      borderRadius: 4,
                      borderTopLeftRadius:0,
                      borderBottomLeftRadius:0,
                      height: 56,
                      width:80,
                      padding:10,
                      color: "white",
                      border: "0px",
                      
                    }}
                // onClick={addFeature}
              >
                ADD
              </button> */}
                  </div>
                )}
              </div>
              <Divider />
              {/* price hours */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  margin:"20px 0px"
                }}
              >
                <div style={{ marginRight: 20, width: "100%" }}>
                  <TextField
                    inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                    label="hours"
                    type="text"
                    fullWidth
                    onChange={handleChange("hours")}
                    value={values.hours}
                    onBlur={handleBlur("hours")}
                    helperText={errors.hours}
                    required
                    FormHelperTextProps={{
                      color: "red",
                      className: classes.helperText
                    }}
                  />
                </div>
                <TextField
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  label="Price"
                  type="text"
                  fullWidth
                  onChange={handleChange("price")}
                  value={values.price}
                  onBlur={handleBlur("price")}
                  required
                  helperText={errors.price}
                  FormHelperTextProps={{
                    color: "red",
                    className: classes.helperText
                  }}
                />
              </div>
              <div
                style={{
                  margin: "20px 0px",
                  // display:'flex'
                }}
              >
                <div
                  style={
                    {
                      // marginRight:20,
                      // width:250,
                    }
                  }
                >
                  <button
                    style={{
                      backgroundColor:
                        points.length > 0 && isValid ? mainColor : "gray",
                      borderRadius: 4,
                      height: 45,
                      width: 280,
                      borderRadius: 6,
                      padding: 10,
                      color: "white",
                      border: "0px",
                      cursor: "pointer",
                    }}
                    disabled={!isValid || points.length == 0}
                    onClick={handleSubmit}
                  >
                    {saveLoad ? "Loading..." : "Save changes"}
                  </button>
                  {/* <CustomButton bg={isValid? mainColor:"gray"} buttonText={"Save changes"} onClick={handleSubmit} /> */}
                  {successAction.visible&&<div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <IconButton
                      sx={{ color: successAction.success?"green":"red" }}
                    >
                      {successAction.success ? <CheckBoxIcon /> : <DangerousIcon />}
                    </IconButton>
                    <p style={{ color: successAction.success ? "green" : "red" }}>
                      {successAction.success ? "Successfuly added your plan" : "Something wen wrong, Failed to add your plan."}
                    </p>
                  </div>}
                </div>
                <Typography variant="body1" color={"red"}>
                  {saveErr}
                </Typography>
              </div>
            </Paper>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default NewPlan;
